import Vue from 'vue'
import App from './App'
import router from '@/router'
import axios from '@/lib/axios'
import config from '@/lib/config'
import store from './store/index'
import { NavBar, Toast, Cell, CellGroup, Popup, Field, Picker, DatetimePicker, Area, List, Icon, Progress, Dialog, PullRefresh, Actionsheet } from 'vant'
import 'vant/lib/index.css'
import 'lib-flexible'
import '@/styles/reset.css'
// import http from '@/assets/js/http'
Vue.use(config)
Vue.use(NavBar)
Vue.use(Popup)
Vue.use(Progress)
Vue.use(Toast)
Vue.use(Field)
Vue.use(Picker)
Vue.use(Area)
Vue.use(Icon)
// Vue.use(ImagePreview)
Vue.use(DatetimePicker)
Vue.use(Dialog)
Vue.use(Actionsheet)
Vue.use(PullRefresh).use(List)
Vue.use(Cell).use(CellGroup)

Vue.prototype.axios = axios

Vue.config.productionTip = false

/* eslint-disable no-new */
new Vue({
    el: '#app',
    router,
    store,
    components: { App },
    template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js